import type { ReactNode, CSSProperties } from 'react';

interface CardProps {
  children: ReactNode;
  style?: CSSProperties;
  padding?: number;
}

export function Card({ children, style, padding = 16 }: CardProps) {
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 8,
        border: '1px solid #e2e8f0',
        padding,
        ...style,
      }}
    >
      {children}
    </div>
  );
}